import React, { useContext } from 'react'

import Cookies from 'js-cookie'
import { Navigate } from 'react-router-dom'

import { UserContext } from '@acre/utils'

import useCasesLandingPath from '@broker-crm-hooks/useCasesLandingPath'

import { checkIfFirstTimeUser } from '../pages/Onboarding/Onboarding.helpers'

export const RedirectOnRoot = () => {
  const user = useContext(UserContext)

  const { isInitialCallComplete, isComplianceUser, path: casesPath } = useCasesLandingPath()

  if (!isInitialCallComplete) {
    return null
  }

  const redirect = Cookies.get('login_redirect')

  const { isFirstTimeUsingAcre } = checkIfFirstTimeUser(user)

  if (redirect) {
    Cookies.remove('login_redirect')
  }

  let path = casesPath

  if (isFirstTimeUsingAcre) {
    path = '/welcome'
  } else if (!isComplianceUser) {
    path = redirect || '/cases/board-view'
  }

  return <Navigate to={path} />
}
